var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Not Found")]),_c('p',[_vm._v(" Ooooops we couldn't find that page. Try going "),_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v("home")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }